import { createApiCallActions } from 'src/app/common/store/generic.actions';
import {
  CarInsuranceContractModel,
  ContractModel,
  ContractStatusFlow,
  ContractStatusHistoryModel,
  CreateContractFormModel,
  HealthInsuranceContractDetailModel,
  HouseInsuranceContractModel,
} from './types';
import { Action } from '../view/types';

export const contractActions = {
  getById: createApiCallActions<ContractModel>('contract', 'getById'),
  getByUniqueId: createApiCallActions<ContractModel>(
    'contract',
    'getByUniqueId',
  ),
  getByLeadId: createApiCallActions<ContractModel>('contract', 'getByLeadId'),
  getHealthDetail: createApiCallActions<HealthInsuranceContractDetailModel[]>(
    'contract',
    'getHealthDetail',
  ),
  getCarDetail: createApiCallActions<CarInsuranceContractModel>(
    'contract',
    'getCarDetail',
  ),
  getHouseDetail: createApiCallActions<HouseInsuranceContractModel>(
    'contract',
    'getHouseDetail',
  ),
  getStatusFlow: createApiCallActions<ContractStatusFlow[]>(
    'contract',
    'getStatusFlow',
  ),
  getStatusActions: createApiCallActions<Action[]>(
    'contract',
    'getStatusActions',
  ),
  confirm: createApiCallActions<string>('contract', 'confirm'),
  saveAsDraft: createApiCallActions<ContractModel>('contract', 'saveAsDraft'),
  requestValidation: createApiCallActions<ContractModel>(
    'contract',
    'requestValidation',
  ),
  validate: createApiCallActions<ContractModel>('contract', 'validate'),
  reject: createApiCallActions<ContractModel>('contract', 'reject'),
  verify: createApiCallActions<ContractModel>('contract', 'verify'),
  suspendContract: createApiCallActions<ContractModel>(
    'contract',
    'suspendContract',
  ),
  closeContract: createApiCallActions<ContractModel>(
    'contract',
    'closeContract',
  ),
  reopenContract: createApiCallActions<ContractModel>(
    'contract',
    'reopenContract',
  ),
  getContractModel: createApiCallActions<ContractModel>(
    'contract',
    'getContractModel',
  ),
  getHealthContractModel: createApiCallActions<
    HealthInsuranceContractDetailModel[]
  >('contract', 'getHealthContractModel'),
  getCarContractModel: createApiCallActions<CarInsuranceContractModel>(
    'contract',
    'getCarContractModel',
  ),
  getHouseContractModel: createApiCallActions<HouseInsuranceContractModel>(
    'contract',
    'getHouseContractModel',
  ),
  createHealhContractModel: createApiCallActions<
    HealthInsuranceContractDetailModel[]
  >('contract', 'createHealhContractModel'),
  createCarContractModel: createApiCallActions<CarInsuranceContractModel>(
    'contract',
    'createCarContractModel',
  ),
  createHouseContractModel: createApiCallActions<HouseInsuranceContractModel>(
    'contract',
    'createHouseContractModel',
  ),
  createContract: createApiCallActions<any>('contract', 'createContract'),
  createHealthContract: createApiCallActions<any>(
    'contract',
    'createHealthContract',
  ),
  createCarContract: createApiCallActions<any>('contract', 'createCarContract'),
  createHouseContract: createApiCallActions<any>(
    'contract',
    'createHouseContract',
  ),
  updateContract: createApiCallActions<string>('contract', 'updateContract'),
  updateHealthContract: createApiCallActions<string>(
    'contract',
    'updateHealthContract',
  ),
  updateCarContract: createApiCallActions<string>(
    'contract',
    'updateCarContract',
  ),
  updateHouseContract: createApiCallActions<string>(
    'contract',
    'updateHouseContract',
  ),
  getIfDataReadOnlyFromContractId: createApiCallActions<boolean>(
    'contract',
    'getIfDataReadOnlyFromContractId',
  ),
  getContractStatusHistory: createApiCallActions<ContractStatusHistoryModel>(
    'contract',
    'getContractStatusHistory',
  ),
  updateContractStatusHistory: createApiCallActions<ContractStatusHistoryModel>(
    'contract',
    'updateContractStatusHistory',
  ),
  deleteContractStatusHistory: createApiCallActions<boolean>(
    'contract',
    'deleteContractStatusHistory',
  ),
};

export type ContractAction = typeof contractActions;
